var layouts = {"primitive":"_primitive_14iew_1","container":"_container_14iew_1","flow":"_flow_14iew_1","page-content":"_page-content_14iew_1","pageContent":"_page-content_14iew_1","page":"_page_14iew_7"};

export { layouts as default };
